import { useState } from "react";
import SubscriptionService from "services/subscription/subscriptionService";
import { ContentType } from "services/subscription/types";

interface CheckAccessArgs {
  slug?: string;
  contentType?: ContentType;
  id?: number;
  isPremiumContent: boolean;
  isCreator?: boolean;
}

export const usePremiumAccess = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const checkAccess = async ({
    slug,
    contentType,
    id,
    isPremiumContent,
    isCreator = false,
  }: CheckAccessArgs): Promise<boolean> => {
    try {
      setIsLoading(true);
      let hasAccess = false;

      if (!isPremiumContent) {
        return true;
      }

      if (slug) {
        const resp = await SubscriptionService.checkContentAccessBySlug(slug);
        hasAccess = resp?.data?.has_access ?? false;
      } else if (contentType !== undefined && id !== undefined) {
        const resp = await SubscriptionService.checkContentAccess(
          contentType,
          id,
        );
        hasAccess = resp?.data?.has_access ?? false;
      }

      const accessDenied =
        (!hasAccess && isPremiumContent) || (!hasAccess && isCreator);
      if (accessDenied) {
        setIsModalOpen(true);
        return false;
      }
      return true;
    } catch (err) {
      console.error("Error checking content access:", err);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isModalOpen,
    setIsModalOpen,
    checkAccess,
    isLoading,
  };
};

export default usePremiumAccess;
